import { render } from "./AddProductModal.vue?vue&type=template&id=b265e666&ts=true"
import script from "./AddProductModal.vue?vue&type=script&lang=ts"
export * from "./AddProductModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__